import { Autoplay, Navigation } from 'swiper';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';

let teamCultureSwiperWr = document.querySelectorAll('.team-culture-swiper-wr');
teamCultureSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    const items = Array.from(wrapper.querySelectorAll(".team-culture__item"));

    if (items.length < 2) return;

    const penultimate = items[items.length - 2];
    const last = items[items.length - 1];

    const isPenultimatePinkText = penultimate.classList.contains("pink-type") &&
        penultimate.classList.contains("text-type");

    const allowedClasses = ["team-culture__item", "swiper-slide"];
    const lastClassList = Array.from(last.classList).filter(c => c.trim() !== "");
    const isLastClean = lastClassList.every(cls => allowedClasses.includes(cls));

    if (isPenultimatePinkText && isLastClean) {
      wrapper.insertBefore(last, penultimate);
    }

    swiperOnResize('(max-width: 768px)', swiperEl, {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 12,
      autoHeight: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        420: {
          spaceBetween: 16,
        }
      },
    });
  }
});